import Axios from "axios";
import {
    SET_ASSET_DEPRECIATION_LIST,
    UNSET_ASSET_DEPRECIATION_LIST,
    SET_VIEWING_ASSET_DEPRECIATION,
    UNSET_VIEWING_ASSET_DEPRECIATION,
    SET_EDITING_ASSET_DEPRECIATION,
    UNSET_EDITING_ASSET_DEPRECIATION,
    SET_ASSET_REGISTER_DEPRECIATION_LIST,
    UNSET_ASSET_REGISTER_DEPRECIATION_LIST,
} from "@/store/mutation-types";

import { saveUpdateAssetDepreciation, getAssetDepreciationsList, getAssetRegisterDepreciationsList, getAssetDepreciationById } from "@/store/api";

const state = {
    getAssetDepreciationsList: [],
    getViewingAssetDepreciation: null,
    getAssetRegisterDepreciationsList: [],
    getEditingAssetDepreciation: null,
};

const getters = {
    getAssetDepreciationsList(state) {
        return state.getAssetDepreciationsList;
    },
    getAssetRegisterDepreciationsList(state) {
        return state.getAssetRegisterDepreciationsList;
    },
    getEditingAssetDepreciation(state) {
        return state.getEditingAssetDepreciation;
    },
    getViewingAssetDepreciation(state) {
        return state.getViewingAssetDepreciation;
    }
};

const mutations = {
    [SET_ASSET_DEPRECIATION_LIST](state, data) {
        state.getAssetDepreciationsList = data;
    },
    [UNSET_ASSET_DEPRECIATION_LIST](state) {
        state.getAssetDepreciationsList = [];
    },
    [SET_VIEWING_ASSET_DEPRECIATION](state, data) {
        state.getViewingAssetDepreciation = data;
    },
    [UNSET_VIEWING_ASSET_DEPRECIATION](state) {
        state.getViewingAssetDepreciation = [];
    },
    [SET_EDITING_ASSET_DEPRECIATION](state, data) {
        state.getEditingAssetDepreciation = data;
    },
    [UNSET_EDITING_ASSET_DEPRECIATION](state) {
        state.getEditingAssetDepreciation = null;
    },
    [SET_ASSET_REGISTER_DEPRECIATION_LIST](state, data) {
        state.getAssetRegisterDepreciationsList = data;
    },
    [UNSET_ASSET_REGISTER_DEPRECIATION_LIST](state) {
        state.getAssetRegisterDepreciationsList = [];
    },
};

const actions = {
    saveUpdateAssetDepreciation({ commit }, data) {
        commit("SET_LOADING", {color: "primary"});
        return new Promise((resolve, reject) => {
            Axios.post(saveUpdateAssetDepreciation, data)
                .then(function (response) {
                    resolve(response);
                })
                .catch(function (error) {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
        });
    },

    getAssetDepreciationsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetDepreciationsList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_DEPRECIATION_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_DEPRECIATION_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },

    getAssetDepreciationById({ commit }, data) {
        const getAssetDpreciationRecordById = `${getAssetDepreciationById}/${data}`;
            commit("SET_LOADING", { color: "primary" });
            return new Promise((resolve, reject) => {
                Axios.get(getAssetDpreciationRecordById)
                    .then((response) => {
                    resolve(response.data); 
                })
                    .catch((error) => {
                    console.error("API Error:", error.response?.data || error.message);
                    reject(error);
                })
                    .finally(() => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },

    getAssetRegisterDepreciationsList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(getAssetRegisterDepreciationsList, { params: data})
                .then(function (response) {
                    commit('SET_ASSET_REGISTER_DEPRECIATION_LIST', response.data.data)
                    resolve(response);
                })
                .catch(function (error) {
                    commit('UNSET_ASSET_REGISTER_DEPRECIATION_LIST')
                    reject(error);
                })
                .then((always) => {
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
